
import { atom } from 'recoil'

export const isOpenEditConfirmationState = atom({
  key: 'isOpenEditConfirmationState',
  default: false
})
